<template>
  <span
    class="inline-flex items-center gap-1 rounded-md font-semibold"
    :class="[variantClass, SIZE_CLASSES[size]]"
  >
    <Zap
      v-if="badge.kind === 'sale'"
      class="h-3 w-3 fill-current text-red-500"
      aria-hidden="true"
    />
    {{ badge.label }}
  </span>
</template>

<script setup lang="ts">
import { Zap } from 'lucide-vue-next'
import type {
  ProductCardBadge,
  ProductCardPartSize,
} from '~/utils/productCardMapper'

const { badge, size = 'default' } = defineProps<{
  badge: ProductCardBadge
  size?: ProductCardPartSize
}>()

const SIZE_CLASSES: Record<ProductCardPartSize, string> = {
  default: 'px-2 py-1 text-caption',
  small: 'px-1.5 py-0.5 text-caption-small',
  responsive:
    // md:font-semibold: the text-caption token resets the weight to 400
    'px-1.5 py-0.5 text-caption-small md:px-2 md:py-1 md:text-caption md:font-semibold',
}

const variantClass = computed(() =>
  badge.kind === 'sale' ? 'bg-white text-red-600' : 'bg-teal-100 text-teal-700'
)
</script>
